import { format as datefnsFormat, endOfYear, startOfWeek } from 'date-fns';
import { TimeRangeOption } from 'types/dashboard';

export const getDatesFromTimeRangeOption = (option: TimeRangeOption | undefined): { from: string; to: string } => {
    const today = new Date();

    const format = (d: Date) => datefnsFormat(d, 'yyyy-MM-dd');

    switch (option) {
        case 'today': {
            return { from: format(today), to: format(today) };
        }
        case 'yesterday': {
            const y = new Date(today);
            y.setDate(today.getDate() - 1);
            return { from: format(y), to: format(y) };
        }
        case 'current-week': {
            const start = startOfWeek(today, { weekStartsOn: 1 });
            return { from: format(start), to: format(today) };
        }
        case 'last-week': {
            const start = startOfWeek(today, { weekStartsOn: 1 });
            start.setDate(start.getDate() - 7);
            const end = new Date(start);
            end.setDate(start.getDate() + 6);
            return { from: format(start), to: format(end) };
        }
        case 'current-month': {
            const start = new Date(today.getFullYear(), today.getMonth(), 1);
            return { from: format(start), to: format(today) };
        }
        case 'last-month': {
            const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            const end = new Date(today.getFullYear(), today.getMonth(), 0);
            return { from: format(start), to: format(end) };
        }
        case 'current-year': {
            const start = new Date(today.getFullYear(), 0, 1);
            return { from: format(start), to: format(today) };
        }
        case 'last-year': {
            const start = new Date(today.getFullYear() - 1, 0, 1);
            const end = endOfYear(start);
            return { from: format(start), to: format(end) };
        }
        default: {
            return { from: '', to: '' };
        }
    }
};
